// extracted by mini-css-extract-plugin
var _1 = "Login-module__forgot_password__N5t_i";
var _2 = "Login-module__forgot_password_container__EIvU5";
var _3 = "Login-module__form__DIxOi";
var _4 = "Login-module__oauth_container__u1LJc";
var _5 = "Login-module__oauth_google_container__NZwU6";
var _6 = "Login-module__or_container__Uc9yu";
var _7 = "Login-module__sign_in_Heading__hkz2u";
var _8 = "Login-module__sign_up__hmKjt";
var _9 = "Login-module__sign_up_container__KFekr";
var _a = "Login-module__submit_button__RKMsG";
export { _1 as "forgot_password", _2 as "forgot_password_container", _3 as "form", _4 as "oauth_container", _5 as "oauth_google_container", _6 as "or_container", _7 as "sign_in_Heading", _8 as "sign_up", _9 as "sign_up_container", _a as "submit_button" }
